import cls from '../../util/cls'

import styles from './request-table.module.css'
import NoContent from '../forms/no-content'

const RequestTable = ({ data = [], onClick, activeId }) => {
    if (data?.length === 0) {
        return <NoContent />
    }

    return (
        <div style={{maxHeight: '100%', overflowY: 'auto'}}>
            <table className={styles.table}>
                {data
                    .sort((a,b) => new Date(b?.createdAt) - new Date(a?.createdAt))
                    .map((x) => (
                        <tr
                            onClick={() => onClick(x?.id)}
                            className={cls(styles.tableCell, activeId === x?.id && styles.tableCellActive)}
                            key={x?.id}
                        >
                            <td style={{ color: 'var(--text-primary)', textAlign: 'left' }}>
                                {x?.id}
                            </td>
                            <td style={{ color: 'var(--text-secondary)', textAlign: 'right', fontSize: '15px' }} >
                                {new Date(x?.createdAt).toLocaleString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })}
                            </td>
                        </tr>
                    ))}

            </table>
        </div>
    )


}

export default RequestTable